// importamos los tipos de mutacion

import * as types from './mutation-types'

const mutations = {
  // PARA CARGAR DATOS E HOME
  [types.LOGIN] (state, token) {
    // el inicio de sesion fue correcto
    localStorage.setItem('token', token)
  },
  [types.LOGOUT] (state) {
    // cambio de estado secion terminada
    localStorage.removeItem('token')
    state.dataUser = null
  },
  [types.SET_USER] (state, data) {
    // seteamos el estado con un obeto user
    state.dataUser = data
  },
  [types.SET_IMAGE_USER] (state, image) {
    // seteamos el estado con un obeto user
    state.dataUser.avatar = image
  },
}

export default mutations
